import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ContactHero from "../components/ContactUs/ContactHero";
import ContactForm from "../components/ContactUs/ContactForm";
import Faqs from "../components/ContactUs/Faqs";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ overflowX: "hidden", backgroundColor: "#F5F7FA" }}>
      <Navbar />
      <ContactHero />
      <ContactForm />
      <Faqs />
      <Footer />
    </Box>
  );
};

export default ContactUs;
